<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_350_7508)">
      <path
        d="M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM18.2178 8.29297C17.8273 7.90247 17.1942 7.90252 16.8037 8.29297L10 15.0947L6.70703 11.8027C6.31652 11.4123 5.68347 11.4123 5.29297 11.8027C4.9025 12.1932 4.90254 12.8263 5.29297 13.2168L9.29297 17.2168C9.6835 17.6073 10.3175 17.6073 10.708 17.2168L18.2178 9.70703C18.6082 9.31653 18.6082 8.68347 18.2178 8.29297Z"
        fill="#63D63B"
      />
    </g>
    <defs>
      <clipPath id="clip0_350_7508">
        <rect
          width="24"
          height="24"
          rx="12"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>